import Vue from 'vue';
// event bus.
var events = new Vue();
export default events;
